import {Separator} from 'platform/components';
import {HStack, Show, Text} from 'platform/foundation';

import {useEffect, useState} from 'react';

import {isNil, isNotNil} from 'ramda';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';

import {formatTimeDifferenceToNow} from '../utils/formatTimeDifferenceToNow';

interface LiveLastUpdateTimeProps {
  lastUpdateTime?: number | null;
}

export function LiveLastUpdateTime(props: LiveLastUpdateTimeProps) {
  const [formattedTime, setFormattedTime] = useState<string | null>(() =>
    isNotNil(props.lastUpdateTime) ? formatTimeDifferenceToNow(props.lastUpdateTime, true) : null
  );

  useEffect(() => {
    if (isNil(props.lastUpdateTime)) {
      setFormattedTime(null);
      return;
    }

    const lastUpdateTimeValue = props.lastUpdateTime;
    const updateTime = () => {
      setFormattedTime(formatTimeDifferenceToNow(lastUpdateTimeValue, true));
    };

    updateTime();
    const intervalId = setInterval(updateTime, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [props.lastUpdateTime]);

  return (
    <Show
      when={isNotNil(formattedTime)}
      whenFeatureEnabled={featureFlags.SOURCING_REAL_TIME_ADVERTISEMENT}
    >
      <Separator orientation="vertical" spacing={0} />
      <HStack align="center" spacing={1}>
        <Text size="xSmall" color="secondary">
          {i18n.t('entity.sourcingTable.labels.lastUpdate')}:
        </Text>
        <Text size="xSmall" color="secondary" alternative>
          {formattedTime}
        </Text>
      </HStack>
    </Show>
  );
}
